const customers = {
  dev: [
    {
      id: '3edeb50f-bc7b-482c-9f01-c50bef6a08f8',
      name: 'Identity 1',
    },
  ],
  int: [
    {
      id: '8dd6bc12-d84d-45ca-afb6-17fc9ac866b7',
      name: 'karen.int8@experian.com',
    },
  ],
};

export default (env = 'dev') => customers[env];
